module.exports = __webpack_public_path__ + "static/media/Newsletter.c7f24d6e.md";